<script>

    // Imports

    import { State, adjustOrderForFixedItems } from '../store.js';
    import { componentsByName, addDefaultStyle } from '../PaywallComponents/components'
    import Section from './Section.svelte';
    import { onDestroy, tick } from 'svelte';
    import { each, element, onMount } from 'svelte/internal';
    import { v4 as uuidv4 } from 'uuid';
    import { addInspectable, addFooterInspectable } from '../inspectable.js';

    // Drag to Rearrange
    let hovering = false;
    let draggingIndex = -1
    let isDragging = false

    $: hasFooterContent = $State.components.filter(c => c.args.meta.section == "footer").length > 1
    $: hasNavbar = $State.components.filter(c => c.type == "navBar").length

    const browserId = uuidv4()

    const endDropIndex = () => {
        let elements = $State.components
        for (let i = 0; i < elements.length; i++) {
            let element = elements[i]
            if (element !== undefined) {
                if (element.type == "fixedFooter") {
                    return i - 1
                } 
            }
        }
        return $State.components.length - 1
    }

    const drop = (event, endTarget) => {
        let target = endTarget === null ? endDropIndex() : endTarget
        event.dataTransfer.dropEffect = 'move'; 
        const data = JSON.parse(event.dataTransfer.getData("text/plain"));

        console.log("DROP!", event)

        const start = data.start
        const componentData = data.data
        const isFromOtherBrowser = data.browserId != browserId

        if (isFromOtherBrowser) {
            console.log("from other broser")
            componentData.id = uuidv4()
            let newTracklist = $State.components
            newTracklist.splice(target + 1, 0, componentData);
            $State.components = adjustOrderForFixedItems(newTracklist)
            hovering = null
            draggingIndex = -1
            isDragging = false
        } else {

            let newTracklist = $State.components

            if (start < target) {
                newTracklist.splice(target + 1, 0, newTracklist[start]);
                newTracklist.splice(start, 1);
            } else {
                newTracklist.splice(target, 0, newTracklist[start]);
                newTracklist.splice(start + 1, 1);
            }

            $State.components = adjustOrderForFixedItems(newTracklist)
            hovering = null
            draggingIndex = -1
            isDragging = false
        }
    }



    var elementHeight = 6

    const dragstart = (event, i) => {
        event.dataTransfer.effectAllowed = 'move';
        event.dataTransfer.dropEffect = 'move';
        const start = i;
        draggingIndex = i;
        event.dataTransfer.setData('text/plain', JSON.stringify({start: start, data: $State.components[start], browserId: browserId}));
        isDragging = true;
        elementHeight = event.target.clientHeight

    }

    const dragend = (event) => {
        isDragging = false; 
        hovering = null; draggingIndex = -1;

    }

    const toggleActive = (componenent) => {
        if (componenent.type != "fixedFooter") {
            $State.activeElementId = componenent.id
        }
	}

    // onDestroy

    onDestroy(() => {
        console.log("paywall destroy")
    })

    // deep merge componenents with their defaults. user settings overwrite defaults

    addDefaultStyle($State)

    let container = {}
    let footerWidth = 100;
    let footerHeight = 100;
    let navbarHeight = 0;
    let footer = null
    let containerHeight = 0

    // const handleResize = () => {
    //     footerWidth = container.clientWidth
    // }

    // const getFooterHeight = () => {
    //     if (footer !== null) {
    //         footerHeight = footer.clientHeight
    //         console.log("footer height", footerHeight)
    //     }
    // }

    // onMount(() => {
    //     handleResize()
    // })

    const elementHeights = {}

    // window.addEventListener('resize', handleResize);


    const unsubscribe = State.subscribe(async (v) => {
        await tick();
        if (footer !== null) {
            addInspectable(footer, $State.page.args, $State.live)
            console.log("added footer inspectable")
            if (v.live) {
                addFooterInspectable($State.page.args)
            }
        }
    })

</script>

<div bind:clientWidth={footerWidth} bind:clientHeight={containerHeight} bind:this={container} class:is-dragging-container={isDragging} style={`--dragged-element-height:${elementHeight}px; --footer-width:${footerWidth}px; --footer-height:${footerHeight}px;  --navbar-height:${elementHeights["navBar"] * hasNavbar}px; --container-height:${containerHeight}`}>

    {#if $State.live} 

        <div class="navbar-padding-fix"/>

        {#each $State.components as component, index}
            {#if component !== undefined} 
                {#if component.args.meta.section === "body"}   
                    <div bind:clientHeight={elementHeights[component.type]} class:navbar-container-live={component.type == "navBar"}>
                        <Section type={componentsByName[component.type][0]} userSettings={component.args} index={index} name={component.args.name}/>
                    </div>
                {/if}
            {/if}
        {/each}

        <div class="paywall-footer live" id="swFooterContainer">
            <div bind:this={footer} bind:clientHeight={footerHeight} id="swFooter"  class="paywall-footer-container" class:has-children={hasFooterContent} data-i-name="footer">
                {#each $State.components as component, index}
                    {#if component !== undefined} 
                        {#if component.args.meta.section === "footer"}   
                            <div>
                                <Section type={componentsByName[component.type][0]} userSettings={component.args} index={index} name={component.args.name}/>
                            </div>
                        {/if}
                    {/if}
                {/each}
            </div>
        </div>


        <div class="footer-padding-fix"/>


    {:else}

        <div class="navbar-padding-fix"/>

        {#each $State.components as component, index (component.id)}
            <!-- <div animate:flip={{duration:500}}> -->

                {#if component !== undefined}
                    {#if component.args.meta.section === "body"}
                        <div
                        bind:clientHeight={elementHeights[component.type]}
                        draggable={$State.previewMode && !$State.live && component.type != "navBar"} 
                        on:dragstart={event => dragstart(event, index)}
                        on:drop|preventDefault={event => drop(event, index)}
                        ondragover="return false"
                        on:click|stopPropagation={toggleActive(component)}
                        on:dragend={dragend}
                        on:dragenter={() => {hovering = index; isDragging = true}}
                        class:navbar-container={component.type == "navBar"}
                        class:is-dragging-over={hovering === index && draggingIndex > hovering && isDragging}
                        class:is-dragging-under={hovering === index && draggingIndex < hovering && isDragging}
                        class:is-dragging-on={hovering === index && draggingIndex == hovering && isDragging}
                        class:is-dragging-me={index == draggingIndex && isDragging}>
                        <Section type={componentsByName[component.type][0]} userSettings={component.args} index={index} name={component.args.name}/>
                        </div>
                    {/if}
                {/if}

        {/each}

        <div class="paywall-footer" id="swFooterContainer" class:preview={!$State.previewMode}>
            <div bind:this={footer} id="swFooter" class="paywall-footer-container" class:has-children={hasFooterContent} data-i-name="footer">
                {#each $State.components as component, index (component.id)}
                <!-- <div animate:flip={{duration:500}}> -->
                    {#if component !== undefined}
                        {#if component.args.meta.section === "footer"}
                            <div
                            draggable={$State.previewMode && !$State.live && component.type != "fixedFooter"} 
                            on:dragstart={event => dragstart(event, index)}
                            on:drop|preventDefault={event => drop(event, index)}
                            ondragover="return false"
                            on:click|stopPropagation={toggleActive(component)}
                            on:dragend={dragend}
                            on:dragenter={() => {hovering = index; isDragging = true}}
                            class:is-dragging-over={hovering === index && draggingIndex > hovering && isDragging}
                            class:is-dragging-under={hovering === index && draggingIndex < hovering && isDragging}
                            class:is-dragging-on={hovering === index && draggingIndex == hovering && isDragging}
                            class:is-dragging-me={index == draggingIndex && isDragging}>
                            <Section type={componentsByName[component.type][0]} userSettings={component.args} index={index} name={component.args.name}/>
                            </div>
                        {/if}
                    {/if}
                {/each}
            </div>
        </div>

        <div class="instructions-container" on:drop={event => drop(event, null)} on:dragover={(ev) => { ev.preventDefault() }}>

        </div>

    {/if}
        

        

</div>


<style>



:global(img) {
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;
}


.instructions-container {
    height: calc(1.0 * var(--footer-width));
    width: 100%;
}


.is-dragging-me {
    /* margin-top: calc(var(--dragged-element-height)/-2); */
    /* margin-bottom: calc(var(--dragged-element-height)/-2); */
    opacity: 0.3;
    transition: all 0.001s;
    /* position: fixed; */
}

:global(.disappear) {
    position: fixed !important;
    right: 100vw;
}

.is-dragging-on {
    margin-top: 0px;
    margin-bottom: 0px;
    opacity: 1;
    /* background-color: rgba(var(--selection-color-rgb), 0.2); */
    opacity: 0.3;
}

:global(.is-dragging-container .section.preview-mode.active) {
    outline: 2px solid rgba(var(--selection-color-rgb), 0.0) !important;
    box-shadow: rgba(var(--selection-color-rgb), 0.0) 0px 0px 1px 4px inset !important;
    background-color: rgba(var(--selection-color-rgb), 0.00) !important;
}

:global(.is-dragging-me .section.preview-mode.active:hover) {
    outline: 2px solid rgba(var(--selection-color-rgb), 0.0) !important;
    box-shadow: rgba(var(--selection-color-rgb), 0.0) 0px 0px 1px 4px inset !important;
    background-color: rgba(var(--selection-color-rgb), 0.00) !important;
    transition: border 0.618s;
}

.is-dragging-over {
    border-top: 2px solid rgba(var(--selection-color-rgb), 1.0);
    margin-top: -2px !important;
}

.is-dragging-under {
    border-bottom: 2px solid rgba(var(--selection-color-rgb), 1.0);
    margin-bottom: -2px !important;
}

.paywall-footer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    /* background-color: lightcyan; */
    position: absolute;
    /* width: calc(var(--footer-width)); */
    bottom: 70px;
    left: calc(50vw - var(--footer-width)/2);
    right: calc(50vw - var(--footer-width)/2);
    z-index: 100;
}

.navbar-container {
    position: absolute;
    /* width: calc(var(--footer-width)); */
    top: 70px;
    left: calc(50vw - var(--footer-width)/2);
    right: calc(50vw - var(--footer-width)/2);
    z-index: 100;
    /* overflow: hidden; */
}

.paywall-footer-container {
    width: var(--footer-width);	

}

.paywall-footer-container.has-children {
    padding-bottom: 26px;
}

.paywall-footer.live {
    left: 0;
    right: 0;
}

/* .paywall-footer-float {
	width: 100%;
	overflow-y: scroll;
	padding: 20px;
	max-width: 400px;
} */

.paywall-footer.preview, .paywall-footer.live {
    position: fixed;
    bottom: 0px;
}

.footer-padding-fix {
    width: 100%; 
    height: var(--footer-height);
}

.navbar-padding-fix {
    height: var(--navbar-height);
    width: 100%; 
}

.navbar-container-live {
    top: 0;
    left: 0; 
    right: 0;
    position: fixed;
    z-index: 100;
    border-radius: 0px;
}

</style>